import { Stack } from '@mui/material';
import { styled } from '@mui/material/styles';

export const ResultHeader = styled(Stack)(({ theme }) => ({
  alignItems: 'baseline',
  flexDirection: 'row',
  flexShrink: 0,
  gap: theme.spacing(0.5),
  paddingBottom: theme.spacing(1.5),
  borderBottom: `1px solid ${theme.palette.divider}`,
}));
